define('responsive-gameday-footer/src/js/GamedayFooter',['require','exports','module','jquery','es6ish-class/es6ish-class','requirejs-hogan-plugin/hogan','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','text!../templates/gd_footer.tpl','gameday-index-url-hasher/UrlHasher','gameday-index-url-hasher/enums/HashEvents','responsive-gameday-footer/src/js/LaunchGameday'],function(require, module, exports) {

    var $ = require('jquery'),
        es6ishClass = require('es6ish-class/es6ish-class'),
        hogan = require('requirejs-hogan-plugin/hogan'),
        MessageService = require("message-service/message-service"),
        LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
        footerTemplate = hogan.compile(require('text!../templates/gd_footer.tpl')),
        UrlHash = require("gameday-index-url-hasher/UrlHasher"),
        HashEvents = require("gameday-index-url-hasher/enums/HashEvents"),
        LaunchGameday = require("responsive-gameday-footer/src/js/LaunchGameday");
        



    var GamedayFooter = es6ishClass(function(selectorString) {

        // Set where on the page this is going on Scoreboard instance creation
        this.targetDivSelector = selectorString;
        this.gameState;
        this.gameData;
        this.miniLink;
        this.views = {
            preview: {
                show: false,
                selector: "#gamestateNavContainer .preview"
            },
            live: {
                show: false,
                selector: "#gamestateNavContainer .live"
            },
            wrap: {
                show: false,
                selector: "#gamestateNavContainer .wrap"
            },
            classic: {
              show:true,
              selector: "#gamestateNavContainer .classic"
            },
            mini: {
              show:true,
              selector: "#gamestateNavContainer .mini"
            }
        }
    });



    GamedayFooter.define({
        /**
         * Where are we placing this component?
         */
        targetDivSelector: "",
        
        setLinksStatus: function() {
           
           if (this.gameState === 'pregame') {
                this.views.preview.show = true;
                this.views.live.show = false;
                this.views.wrap.show = false;
                this.views.mini.show = false;
            } 
            
            if (this.gameState === 'live') {
                this.views.preview.show = true;
                this.views.live.show = true;
                this.views.wrap.show = false;
                this.views.mini.show = true;
            } 
            
            if (this.gameState === 'wrapup') {
                this.views.preview.show = true;
                this.views.live.show = true;
                this.views.wrap.show = true;
                this.views.mini.show = true;
            } 
        
        },
        
        showHideLinks: function() {
            var k,
                link,
                $link;
            for (k in this.views) {
                link = this.views[k];
                $link = $(link.selector);
                if (link.show) {
                    $link.show();
                } else {
                    $link.hide();
                }
                if(($link.attr('data-state') || "").toLowerCase() === this.viewState){
                    $link.addClass('active');
                }else{
                    $link.removeClass('active');
                }
            }
        },
        setData : function(){
            this.gameData = GDC.getGameData().linescore;
            this.hashState= UrlHash.getHashParams();
            this.gameState = (this.gameData && this.gameData.liveState||'').toLowerCase();
            this.viewState = (this.hashState.game_state || this.gameState).toLowerCase();

        },
        updateFooter: function() {
            this.setData();
            this.setLinksStatus();
            this.showHideLinks();
        },
        
        createFooter: function() {
            var that = this;
           
            this.views.classic.link = "/mlb/gameday/index.jsp?gid=" + GDC.getCurrent().gameID + "&mode=classic";
            
            //get links status
            this.setLinksStatus();

            $(this.targetDivSelector).html(footerTemplate.render(this.views));
            this.miniLink = $("#gamedayMiniLinkContainer");
            
            this.showHideLinks();

            // bind the stuff
            $(this.targetDivSelector).on('click', "#gamestateNavContainer a", function(e) {
                e.preventDefault();
                var currentElement = $(this).parent(),
                    linkState=currentElement.attr("data-state");
                
                if (linkState) {
                  if(linkState.toLowerCase() === that.gameState){
                    UrlHash.removeHashParam('lock_state');
                    UrlHash.setHashParams({
                      game_state: linkState
                    });
                  } else {
                    UrlHash.setHashParams({
                      lock_state: linkState
                    });
                  }
                }
                
                if (currentElement.attr("id") === "gamedayMiniLinkContainer") {
                   LaunchGameday({mode: 'mini', gid: UrlHash.getHashParams().game})
                }
                
                if (currentElement.attr("id") === "gamedayClassicLink") {
                   window.location.href = "/mlb/gameday/index.jsp?gid="+UrlHash.getHashParams().game+"&mode=classic";
                }

            });


        },

        init: function(config) {
            var that = this;

            MessageService.one("init_data_loaded", function() {
                that.setData();
                that.createFooter();
                MessageService.on(HashEvents.GAME_STATE_CHANGED, function() {
                    that.updateFooter()
                });
                MessageService.on("init_data_loaded", function() {
                    that.updateFooter()
                });
            });
            
            
          
        }
    });

    return GamedayFooter;
});
